import React from 'react';
import { useFetchDeviceHistoryQuery } from '~/api/controlDevice/ControlDevice.api';
import Spinner from '@rio-cloud/rio-uikit/lib/es/Spinner';
import ListTableTS from '~/features/base/components/table/ListTableTS';
import DefaultWhiteColumn from "~/features/base/components/DefaultWhiteColumn";
import NotFoundState from '@rio-cloud/rio-uikit/lib/es/NotFoundState';
import { FormattedMessage } from 'react-intl';
import ReloadButton from '~/features/base/components/ReloadButton';
import TableReloadAndItems from '~/features/base/components/TableReloadAndItems';
import { deviceHistoryColumnDescriptors } from './deviceHistoryColumnDescriptors';
import OverlayTrigger from "@rio-cloud/rio-uikit/lib/es/OverlayTrigger";
import Tooltip from "@rio-cloud/rio-uikit/lib/es/Tooltip";

const DeviceHistory = ({ serialNumber }) => {
    const [page, setPage] = React.useState(0);
    const [allItems, setAllItems] = React.useState([]);
    const pageSize = 10;
    const { data, isLoading, error, refetch } = useFetchDeviceHistoryQuery({
        serialNumber,
        page,
        size: pageSize,
    });

    React.useEffect(() => {
        if (data?.content) {
            if (page === 0) {
                setAllItems(data.content);
            } else {
                setAllItems(prev => [...prev, ...data.content]);
            }
        }
    }, [data, page]);

    const handleReloadClick = () => {
        if (page === 0) refetch();
        else setPage(0);
    };

    const handleLoadMore = () => {
        setPage(page + 1);
    };

    const hasMoreHistory = () => {
        if (data?.totalElements && allItems.length) {
            return data.totalElements > allItems.length;
        }
        return false;
    };

    if (isLoading) return <Spinner text={<FormattedMessage id="intl-msg:loadingHistory" />} />;
    if (error) return <div><FormattedMessage id="intl-msg:errorLoadingHistory" /></div>;

    if (!isLoading && (!allItems || allItems.length === 0)) {
        return (
            <div style={{ backgroundColor: '#F5F5F5' }} className="padding-bottom-10">
                <div className="display-flex flex-column">
                    <div className="rounded-large bg-white margin-top-10 margin-left-10 margin-right-10 padding-20">
                        <NotFoundState
                            fullWidth
                            headline={<FormattedMessage id='intl-msg:nothingFound'/>}
                            message={
                                <div className='display-flex' style={{ flexDirection: 'column' }}>
                                    <div className='margin-bottom-25'><FormattedMessage id='intl-msg:noDeviceHistoryAvailable'/></div>
                                    <ReloadButton onReloadClick={handleReloadClick}/>
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: '#F5F5F5' }} className="padding-bottom-10">
            <div className="display-flex flex-column">
                <div className="rounded-large bg-white margin-top-10 margin-left-10 margin-right-10 padding-20">
                    <div className='margin-bottom-15 display-flex align-items-center'>
                        <h5 className='h5'><FormattedMessage id='intl-msg:deviceHistory'/></h5>
                        <OverlayTrigger
                            key={1}
                            placement={'right-start'}
                            overlay={
                                <Tooltip id='tooltip' allowOnTouch>
                                    <span><FormattedMessage id='intl-msg:deviceHistoryInfo'/></span>
                                </Tooltip>
                            }
                        >
                            <span className="rioglyph rioglyph-info-sign margin-left-10 label-info" style={{fontSize: '18px'}} aria-hidden="true"></span>
                        </OverlayTrigger>
                    </div>
                    <div className='display-flex justify-content-between margin-bottom-15'>
                        <TableReloadAndItems itemsCount={data?.totalElements || 0} onReload={refetch}/>
                    </div>
                    <ListTableTS
                        items={allItems}
                        columnDescriptors={deviceHistoryColumnDescriptors}
                        itemKey="changeTimestamp"
                    />
                    <div className="padding-top-20 display-flex justify-content-center">
                        <button
                            disabled={!hasMoreHistory()}
                            className='btn btn-default'
                            onClick={handleLoadMore}
                        >
                            <FormattedMessage id='intl-msg:loadMore'/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceHistory;
